export function sanitizeCustomerReturnTo(value: string | null, origin: string): string {
  try {
    const url: URL = new URL(value?.trim() || '/timeline', origin);
    if (
      url.origin !== origin ||
      /^\/(api|login|signup|callback|logout)(\/|$)/.test(url.pathname)
    ) {
      return '/timeline';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/timeline';
  }
}
